module.exports = "<div class=row> <circle-progress color=red></circle-progress> <circle-progress color=teal size=small></circle-progress> <circle-progress color=yellow size=big></circle-progress> <circle-progress active flash></circle-progress> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/demos/progresses/circle-progress-demo.vue
 ** module id = 367
 ** module chunks = 0
 **/